import React, { useState, useEffect } from "react";
import interestsAndHobbiesOptions from "./data/interestsAndHobbies.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const InterestsAndHobbiesComponent = ({ user }) => {
  const [interestsAndHobbies, setInterestsAndHobbies] = useState(
    interestsAndHobbiesOptions.interestsAndHobbies.map((hobby) => ({
      text: hobby,
      isSelected: false,
    }))
  );

  const [validationError, setValidationError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    if (user && user.id) {
      const fetchInterestsAndHobbies = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const userInterestsAndHobbies =
            fetchedUserData.interestsAndHobbies || [];

          const updatedInterestsAndHobbies =
            interestsAndHobbiesOptions.interestsAndHobbies.map((hobby) => ({
              text: hobby,
              isSelected: userInterestsAndHobbies.includes(hobby),
            }));

          setInterestsAndHobbies(updatedInterestsAndHobbies);
        } catch (error) {
          console.error("Failed to fetch interests and hobbies data:", error);
        }
      };

      fetchInterestsAndHobbies();
    }
  }, [user, baseURL]);

  const toggleInterestsAndHobbiesSelection = (index) => {
    const newHobbies = [...interestsAndHobbies];
    newHobbies[index].isSelected = !newHobbies[index].isSelected;

    console.log(
      `Hobby: ${newHobbies[index].text} ${
        newHobbies[index].isSelected ? "Selected" : "Deselected"
      }`
    );

    setInterestsAndHobbies(newHobbies);
    setValidationError("");
  };

  const handleSave = async () => {
    setValidationError("");

    const isAnyInterestOrHobbySelected = interestsAndHobbies.some(
      (hobby) => hobby.isSelected
    );

    if (!isAnyInterestOrHobbySelected) {
      setValidationError("Please select at least one interest or hobby.");
      return;
    }

    const selectedInterestsAndHobbies = interestsAndHobbies
      .filter((hobby) => hobby.isSelected)
      .map((hobby) => hobby.text);

    const interestsAndHobbiesData = {
      interestsAndHobbies: selectedInterestsAndHobbies,
    };

    console.log(
      "Selected interests and hobbies for patching:",
      selectedInterestsAndHobbies
    );

    try {
      const response = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        interestsAndHobbiesData
      );

      if (response.data) {
        console.log("Interests and hobbies update successful");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Failed to update interests and hobbies", error);
      setValidationError("Failed to update. Please try again.");
    }
  };

  return (
    <div className="interests-hobbies-component-container">
      {showModal && <SuccessModal />}
      <div className="interests-hobbies-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Interests & hobbies</h2>
        </div>
        
        <p>
          Select the things that you enjoy doing. Clients are more likely to
          find Support Workers who share similar interests.
        </p>
      </div>

      <div className="interests-hobbies-buttons-container">
        {interestsAndHobbies.map((hobby, index) => (
          <button
            key={hobby.text}
            className={`interests-hobbies-horizontal-button ${
              hobby.isSelected ? "selected" : ""
            }`}
            onClick={() => toggleInterestsAndHobbiesSelection(index)}
          >
            <div className="button-checkmark">
              {hobby.isSelected ? "✓" : ""}
            </div>
            <div className="button-text">{hobby.text}</div>
          </button>
        ))}
      </div>
      {validationError && (
        <div className="hobbies-error">{validationError}</div>
      )}
      <div className="hobbies-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default InterestsAndHobbiesComponent;
